/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../../app/store';
import { DigitalAssistantFeedbackTypes } from './FeedbackType';

export interface FeedbackState {
  isFeedbackActive: boolean;
  analyticsCounts: { [event: string]: number };
  defaultSelection: DigitalAssistantFeedbackTypes | undefined;
}
const initialState: FeedbackState = {
  isFeedbackActive: false,
  analyticsCounts: {},
  defaultSelection: undefined,
};
export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    toggleFeedback: (state, action: PayloadAction<DigitalAssistantFeedbackTypes | undefined>) => {
      state.isFeedbackActive = !state.isFeedbackActive;
      state.defaultSelection = action.payload;
    },
    closeFeedback: (state) => {
      state.isFeedbackActive = false;
    },
    incrementAnalyticsCount: (state, action) => {
      state.analyticsCounts[action.payload] = (state.analyticsCounts[action.payload] ?? 0) + 1;
    },
    analyticsCountReset: (state) => {
      state.analyticsCounts = {};
    },
  },
});
export const { toggleFeedback, closeFeedback, incrementAnalyticsCount, analyticsCountReset } = feedbackSlice.actions;
export const selectFeedbackInfo = (state: RootState): FeedbackState => state.feedback;
export const selectShowFeedback = (state: RootState): boolean => state.feedback.isFeedbackActive;
export const selectPatientSummaryFeedback = (state: RootState): DigitalAssistantFeedbackTypes | undefined =>
  state.feedback.defaultSelection;

export default feedbackSlice.reducer;

/** Helper function to count and track the number of analytics events */
(window as any).incrementAnalyticsCount = (event: string) => window.store.dispatch(incrementAnalyticsCount(event));
